import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useTracking from 'hooks/useTracking';
import useFetch from 'hooks/useFetch';
import FeedbackFormModal from 'components/FeedbackFormModal';
import { nextPromoAfterItemUpload } from 'state/profile/actions';
import * as selectors from 'state/profile/selectors';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { sendItemUploadFeedback, getItemUploadFeedbackRatings } from 'data/api';
import { clickEvent, viewScreenEvent } from 'libs/common/event-tracker/events';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { Screen } from 'constants/tracking/screens';
import { transformFeedbackRatingsResponse } from 'data/api/transformers/response';
import { jsx as _jsx } from "react/jsx-runtime";

const ItemUploadFeedback = _ref => {
  let {
    onClose
  } = _ref;
  const {
    0: isModalOpen,
    1: setIsModalOpen
  } = useState(false);
  const dispatch = useDispatch();
  const feedbackItemId = useSelector(selectors.getFeedbackItemId);
  const isFeedbackEnabled = useSelector(getIsFeatureSwitchEnabled('item_upload_feedback_form'));
  const {
    track
  } = useTracking();
  const {
    fetch: fetchItemUploadFeedback,
    error,
    transformedData: feedbackRatings
  } = useFetch(getItemUploadFeedbackRatings, transformFeedbackRatingsResponse);
  useEffect(() => {
    fetchItemUploadFeedback();
  }, [fetchItemUploadFeedback, track, isFeedbackEnabled]);
  useEffect(() => {
    if (error) {
      dispatch(nextPromoAfterItemUpload());
      return;
    }

    if (!feedbackRatings) return;
    setIsModalOpen(true);
    track(viewScreenEvent({
      screen: Screen.ItemUploadFeedbackForm
    }));
  }, [feedbackRatings, error, dispatch, track]);

  const handleModalClose = function () {
    let finalized = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setIsModalOpen(false);
    dispatch(nextPromoAfterItemUpload());
    if (finalized) return;
    track(clickEvent({
      screen: Screen.ItemUploadFeedbackForm,
      target: ClickableElement.CloseScreen
    }));
  };

  const updateFeedbackOptions = async _ref2 => {
    let {
      finalized,
      rating,
      message,
      feedbackStatementIds
    } = _ref2;
    if (!finalized) return;
    await sendItemUploadFeedback({
      itemId: feedbackItemId,
      rating,
      finalized,
      comment: message || '',
      feedbackStatementIds
    });
    handleModalClose(true);
    onClose();
  };

  return /*#__PURE__*/_jsx(FeedbackFormModal, {
    isOpen: isModalOpen,
    ratings: feedbackRatings,
    isInputWithoutRatingOptions: true,
    isCloseActionVisible: false,
    onClose: handleModalClose,
    onSubmit: updateFeedbackOptions
  });
};

export default ItemUploadFeedback;